<template>
  <section class="w-full max-w-md">
    <h6 class="text-center mb-4">
      {{ $root.pageTitle }}
    </h6>

    <div class="">
      <div
        v-if="missing_data"
        class="notice-block is-danger-light"
      >
        <p class="has-text-weight-bold has-text-centered">
          Invalid password reset link.
        </p>
        <p>It may be expired, truncated or incorrect. Please check again your password reset link or ask for a new one.</p>
      </div>
      <div
        v-else
        class="box"
      >
        <form @submit="resetPassword">
          <div class="field">
            <div class="control">
              <label class="label">New password</label>
              <p class="control has-icons-left has-icons-right">
                <input
                  ref="password"
                  class="input"
                  type="password"
                  placeholder="New password"
                  name="password"
                  required
                >
                <span
                  ref="eye"
                  class="icon is-small is-right"
                  @click="showPassword"
                >
                  <i class="fas fa-eye" />
                </span>
              </p>
            </div>
          </div>
          <button class="button is-block is-info is-fullwidth">
            Reset password
          </button>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
import AuthService from '../../../services/auth.service';

const authService = new AuthService();
export default {
  name: 'WorkflowDetails',
  data() {
    return {
      uuid: '',
      random_key: '',
      missing_data: true,
      passwordInputConfig: {
        text: {
          type: 'password',
          color: '#dbdbdb'
        },
        password: {
          type: 'text',
          color: '#000'
        }
      }
    };
  },
  mounted() {
    this.$root.pageTitle = 'Reset your password';
    this.$root.showHeader = false;
    this.random_key = this.$route.query.key;
    this.uuid = this.$route.params.uuid;

    if (this.random_key && this.uuid) {
      this.missing_data = false;
    }
  },
  methods: {
    showPassword(event) {
      const { password, eye } = this.$refs;
      if (password.disabled) return;
      if (event) event.preventDefault();

      const { type, color } = this.passwordInputConfig[password.type];
      password.type = type;
      eye.style.color = color;
    },
    resetPassword(event) {
      if (event) event.preventDefault();

      const passwordInput = this.$refs.password;

      // @todo should be refs instead
      const elButton = this.$el.querySelector('button');
      elButton.classList.add('is-loading');

      const data = new FormData();
      const self = this;
      data.append('new_password', this.$refs.password.value);
      data.append('uuid', this.uuid);
      data.append('random_key', this.random_key);
      passwordInput.disabled = true;

      authService.resetPassword(data)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('setToastQueue', { name: 'resetPassword', data: { message, options: { cssClass: 'is-success', duration: 5000 } } });
            self.$router.push({ name: 'login' });
          } else {
            passwordInput.disabled = false;
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
          self.$refs.password.value = '';
          elButton.classList.remove('is-loading');
        })
        .catch(() => {
          passwordInput.disabled = false;
          self.$root.$emit('showToast', { message: 'Impossible to perform this action.', options: { cssClass: 'is-danger', duration: 10000 } });
          elButton.classList.remove('is-loading');
        });
    }
  }
};
</script>
<style scoped>
    .control.has-icons-left .icon, .control.has-icons-right .icon {
        height: auto;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: inherit;
        cursor: pointer;
    }

    .input:disabled {
        opacity: 0.5;
    }

    .input:disabled + span {
        color: #dbdbdb;
    }
</style>
